import React, { useMemo, useState } from "react";
import { UserPlus } from "lucide-react";

export const OverallAthletePicker = ({ athletes, cats, excludeIds, onAdd, testId }) => {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const catName = useMemo(() => Object.fromEntries(cats.map((c) => [c.id, c.nome])), [cats]);

  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    return athletes
      .filter((a) => !excludeIds.includes(a.id))
      .filter((a) => !s || a.nome.toLowerCase().includes(s) || String(a.numero || "").includes(s) || (catName[a.category_id] || "").toLowerCase().includes(s))
      .slice(0, 40);
  }, [athletes, excludeIds, q, catName]);

  if (!open) {
    return (
      <button type="button" className="btn-ghost inline-flex items-center gap-2 text-xs" onClick={() => setOpen(true)} data-testid={`${testId}-open`}>
        <UserPlus size={14} /> Adicionar atleta
      </button>
    );
  }
  return (
    <div className="border border-[#C9A84C]/40 rounded-sm p-3 bg-black/30" data-testid={testId}>
      <div className="flex gap-2 items-center mb-2">
        <input
          autoFocus
          className="input-field flex-1 !py-1.5 text-sm"
          placeholder="Buscar por nome, nº ou categoria (ex: Novice, Natural)..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
          data-testid={`${testId}-search`}
        />
        <button type="button" className="btn-ghost text-xs" onClick={() => { setOpen(false); setQ(""); }} data-testid={`${testId}-close`}>Fechar</button>
      </div>
      <div className="max-h-56 overflow-y-auto divide-y divide-white/5">
        {list.length === 0 && <div className="text-xs text-[var(--text-secondary)] p-2">Nenhum atleta encontrado.</div>}
        {list.map((a) => (
          <button
            key={a.id}
            type="button"
            className="w-full text-left flex items-center gap-3 p-2 text-sm hover:bg-[var(--bg-surface-hover)]"
            onClick={() => { onAdd(a.id); setOpen(false); setQ(""); }}
            data-testid={`${testId}-item-${a.id}`}
          >
            <span className="tabular-nums font-bold w-8 text-[#C9A84C]">{a.numero ?? "—"}</span>
            <span className="flex-1 truncate">{a.nome}</span>
            <span className="text-xs text-[var(--text-secondary)] truncate max-w-[45%]">{catName[a.category_id] || "—"}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
